/* unplugin-vue-components disabled */import { render } from "./icon_balloon.vue?vue&type=template&id=3abb8011&scoped=true"
const script = {}

import "./icon_balloon.vue?vue&type=style&index=0&id=3abb8011&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abb8011"]])

export default __exports__